/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import * as queryString from 'query-string';

export const getQueryString = (parameters: { [key: string]: string | number }): string => {
  const queryFilterParameters: { [key: string]: string } = {};
  Object.entries(parameters).forEach(([key, value]: any) => {
    queryFilterParameters[key] =
      value.value !== undefined
        ? // eslint-disable-next-line
          value.value.toString().replace(/[^\x00-\x7F]/g, '')
        : undefined;
  });
  return queryString.stringify(queryFilterParameters);
};

export function isNumeric(n: any): n is number | string {
  return !isNaN(parseFloat(n)) && isFinite(n) && !n.toString().match(/[Ee,]/g);
}

export function getConcentrationUnit(translationKey: string): string {
  if (translationKey === 'ozone') {
    return 'ppm';
  }
  return '%'
}

export const isMobile = (window: Window) => window.innerWidth < 768;
